import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const SEO = ({ 
  title, 
  description, 
  keywords,
  image,
  schema,
  canonicalUrl 
}) => {
  const location = useLocation();
  const siteUrl = 'https://masterjewelersga.com'; // Update with actual domain
  const currentUrl = `${siteUrl}${location.pathname}`;
  
  const defaultTitle = 'Master Jewelers | Custom Engagement Rings & While-You-Wait Repair | Cumming & Alpharetta, GA';
  const defaultDescription = 'Family-owned jewelry store specializing in custom engagement rings, lab grown diamonds, vintage designs, and while-you-wait repairs in 15-60 minutes. Halo, oval, emerald cut, and pear shaped engagement rings. 30-50% savings vs chain stores. Serving Atlanta, Roswell, Johns Creek, and all of North Georgia.';
  const defaultKeywords = 'custom engagement rings Georgia, lab grown diamond engagement rings, vintage engagement rings near me, oval engagement rings, emerald cut engagement rings, halo engagement rings, jewelry repair near me, while you wait jewelry repair, pear shaped engagement rings, marquise diamond rings, custom name necklaces, jewelry engraving services, personalized jewelry, anniversary rings, Valentine\'s Day jewelry, Mother\'s Day jewelry gifts, graduation jewelry, birthstone jewelry, bespoke jewelry design, engagement ring designers, jewelry store North Georgia, family jewelers Cumming GA, custom rings Alpharetta';
  const defaultImage = `${siteUrl}/og-image.jpg`;
  
  const finalTitle = title || defaultTitle;
  const finalDescription = description || defaultDescription;
  const finalKeywords = keywords ? `${keywords}, ${defaultKeywords}` : defaultKeywords;
  const finalImage = image || defaultImage;
  const finalCanonicalUrl = canonicalUrl || currentUrl;

  // Base structured data for LocalBusiness
  const baseStructuredData = {
    "@context": "https://schema.org",
    "@type": "JewelryStore",
    "name": "Master Jewelers",
    "description": finalDescription,
    "url": siteUrl,
    "telephone": "(770) 410-1119",
    "priceRange": "$$",
    "servesCuisine": "Jewelry",
    "paymentAccepted": "Cash, Credit Card, Debit Card",
    "currenciesAccepted": "USD",
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        "opens": "10:00",
        "closes": "19:00"
      }
    ],
    "location": [
      {
        "@type": "Place",
        "name": "Master Jewelers - Alpharetta",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "2150 North Point Cir",
          "addressLocality": "Alpharetta",
          "addressRegion": "GA",
          "postalCode": "30022",
          "addressCountry": "US"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": "34.0754",
          "longitude": "-84.2941"
        }
      },
      {
        "@type": "Place",
        "name": "Master Jewelers - Cumming",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "410 Peachtree Pkwy #4114",
          "addressLocality": "Cumming",
          "addressRegion": "GA",
          "postalCode": "30041",
          "addressCountry": "US"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": "34.2073",
          "longitude": "-84.1402"
        }
      }
    ],
    "areaServed": [
      {
        "@type": "City",
        "name": "Cumming"
      },
      {
        "@type": "City",
        "name": "Alpharetta"
      },
      {
        "@type": "City",
        "name": "Roswell"
      },
      {
        "@type": "City",
        "name": "Johns Creek"
      },
      {
        "@type": "City",
        "name": "Milton"
      },
      {
        "@type": "City",
        "name": "Suwanee"
      },
      {
        "@type": "City",
        "name": "Atlanta"
      },
      {
        "@type": "City",
        "name": "Marietta"
      },
      {
        "@type": "City",
        "name": "Kennesaw"
      },
      {
        "@type": "City",
        "name": "Duluth"
      },
      {
        "@type": "City",
        "name": "Lawrenceville"
      }
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Jewelry Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "While-You-Wait Jewelry Repair",
            "description": "Most repairs completed in 15-60 minutes while you wait"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Custom Engagement Rings",
            "description": "Bespoke engagement rings with lab grown diamonds, vintage designs, halo, oval, emerald cut, and pear shaped diamonds"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Lab Grown Diamond Engagement Rings",
            "description": "Custom lab grown diamond engagement rings in all popular cuts and settings"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Vintage Engagement Ring Design",
            "description": "Vintage-inspired and antique engagement ring designs and restorations"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Jewelry Engraving Services",
            "description": "Personalized jewelry engraving for wedding bands, anniversary rings, and custom pieces"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Ring Sizing",
            "description": "Professional ring sizing completed same day"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Watch Repair",
            "description": "Battery replacement and watch repair services"
          }
        }
      ]
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "500",
      "bestRating": "5",
      "worstRating": "1"
    },
    "review": [
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        },
        "author": {
          "@type": "Person",
          "name": "Sarah M."
        },
        "reviewBody": "Amazing service! They resized my ring while I waited. 30 minutes and saved me hundreds compared to the mall jewelry stores."
      }
    ],
    "sameAs": [
      "https://www.facebook.com/masterjewelersga",
      "https://www.instagram.com/masterjewelersga"
    ]
  };

  const finalStructuredData = schema || baseStructuredData;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{finalTitle}</title>
      <meta name="title" content={finalTitle} />
      <meta name="description" content={finalDescription} />
      <meta name="keywords" content={finalKeywords} />
      <link rel="canonical" href={finalCanonicalUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:image" content={finalImage} />
      <meta property="og:site_name" content="Master Jewelers" />
      <meta property="og:locale" content="en_US" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={currentUrl} />
      <meta property="twitter:title" content={finalTitle} />
      <meta property="twitter:description" content={finalDescription} />
      <meta property="twitter:image" content={finalImage} />
      
      {/* Additional Meta Tags */}
      <meta name="robots" content="index, follow" />
      <meta name="googlebot" content="index, follow" />
      <meta name="google" content="notranslate" />
      <meta name="format-detection" content="telephone=no" />
      <meta name="geo.region" content="US-GA" />
      <meta name="geo.placename" content="Cumming, Alpharetta" />
      <meta name="geo.position" content="34.0754;-84.2941" />
      <meta name="ICBM" content="34.0754, -84.2941" />
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(finalStructuredData)}
      </script>
      
      {/* Preconnect to external domains */}
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
    </Helmet>
  );
};

export default SEO;
